module.exports = __webpack_public_path__ + "img/delivery-address-icons.bf0d6c6b.svg";